export default "__VITE_ASSET__2Sl7HlMhijdUUph45mXJlg__"